<script setup lang="ts">
import { computed, onMounted } from 'vue';
import ProgressFrame from './layout/ProgressFrame.vue';
import VisualSuccess from '../components/VisualSuccess.vue';
import ButtonPrimary from '@/shared/components/button/ButtonPrimary.vue';
import { useCommissioningDeviceStore } from '../stores/commissioningDeviceStore';
import { useDeviceSpecificationStore } from '../stores/deviceSpecificationStore';
import { usePollingStore } from '../stores/pollingStore';
import { PollKey } from '../models/Poll';
import router from '@/router';

const deviceSpecificationStore = useDeviceSpecificationStore();
const commissioningDeviceStore = useCommissioningDeviceStore();
const pollingStore = usePollingStore();

const needsSoftwareUpdate = computed(
  () => commissioningDeviceStore.softwareUpdate.needSoftwareUpdate,
);

onMounted(() => {
  pollingStore.start(PollKey.WIFI_STATUS);
});

const goToSoftwareUpdate = () => {
  router.replace({ name: 'SoftwareUpdate' });
};

const goToProjectSection = () => {
  if (deviceSpecificationStore.hasAssignedSite) {
    router.push({ name: 'ConfigureSolshareConfirmSite' });
  } else {
    router.push({ name: 'ProjectSelect' });
  }
};
</script>

<template>
  <ProgressFrame pageClass="fullfocus-page">
    <div class="content">
      <VisualSuccess>
        <template #title>We found your SolShare</template>
      </VisualSuccess>

      <div class="action-container">
        <template v-if="needsSoftwareUpdate">
          <p class="h4 solshare-software__description">
            This SolShare requires a software update before proceeding.
            <span class="solshare-software__description-note">
              Do not power off SolShare until the update has been completed successfully.
            </span>
          </p>

          <ButtonPrimary
            block
            class="cta-button"
            @click="goToSoftwareUpdate"
            data-tn="update-software-btn"
          >
            Update now
          </ButtonPrimary>
        </template>

        <template v-else>
          <p class="h4 solshare-software__description">
            This SolShare is running the latest software version.
          </p>
          <ButtonPrimary
            block
            class="cta-button"
            @click="goToProjectSection"
            data-tn="goto-project-btn"
          >
            Next
          </ButtonPrimary>
        </template>
      </div>
    </div>
  </ProgressFrame>
</template>

<style lang="less" scoped>
.action-container {
  width: 100%;
}

.cta-button {
  margin-top: 1.25rem;
}

.solshare-software__description {
  text-align: center;

  .solshare-software__description-note {
    margin-top: 0.5rem;
    display: block;
  }
}
</style>
